import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CustomerTypeApi } from '../api/customertype.api';
import { switchMap, map } from 'rxjs/operators';

import { CustomerTypeData, CustomerType } from '../../../interfaces/masters/customertype' ;
@Injectable()
export class CustomerTypeService extends CustomerTypeData {

    constructor(private api: CustomerTypeApi) {
      super();
    }
  
  
    list(url: string): Observable<CustomerType[]> {
      
      return this.api.list(url);
    }
  
    getById(url:string): Observable<CustomerType>{
        return this.api.getById(url);
    }
  
    create(url: string, data:CustomerType): Observable<CustomerType[]> {
      
      return this.api.add(url,data);
    }
  
    update(url: string, data:CustomerType): Observable<CustomerType> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  